import { Token } from '@angular/compiler/src/ml_parser/lexer';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { from } from 'rxjs';
import { UserManagementService } from 'src/app/Service/user-management.service';

@Component({
  selector: 'app-session-expire',
  templateUrl: './session-expire.component.html',
  styleUrls: ['./session-expire.component.scss']
})
export class SessionExpireComponent implements OnInit {
  formDetail: FormGroup;
  dialogRef: any;
  constructor(
    
    private fb: FormBuilder, 
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private authService: MsalService, 
    private router: Router) { }
    ngOnInit(): void {
      this.formDetail = this.fb.group({
       });
    }
   
    open(){
      this.authService.loginRedirect();
      // this.authService.loginPopup()
      this.router.navigateByUrl('/login');
    }
   
}
